import styled from 'styled-components'

export const Menu = styled.div`
  @media (min-width: 660px) and (max-width: 2400px) {
    display: none;
  }
`
